import { Link, NavLink } from "react-router-dom";
import OpenTeleLogo from "../../../assets/images/open-tele.svg";
import useImg from "../../../assets/images/user.png";
import { SidebarInterface } from "../../../interfaces";

const Sidebar: React.FC<SidebarInterface> = ({
  sidebarOpen,
  setSidebarOpen,
}) => {
  return (
    <div className="text-gray-800 bg-gray-100  lg:flex font-dm-sans">
      <div
        onClick={() => setSidebarOpen(false)}
        className={
          "fixed inset-0 z-20 transition-opacity bg-black opacity-50 lg:hidden " +
          (sidebarOpen ? "block" : "hidden")
        }></div>

      <div
        className={
          "fixed inset-y-0 right-0 z-30 flex flex-col h-full transition duration-200 transform bg-white border-r border-gray-200 lg:translate-x-0 lg:relative lg:inset-0 " +
          (sidebarOpen ? "translate-x-0 ease-in" : "translate-x-full ease-out")
        }>
        <div className="flex flex-col items-center justify-between px-1 pt-8 pb-5">
          <div className="flex items-center space-x-4 mb-4">
            <img src={OpenTeleLogo} alt="" />
          </div>

          <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M8.75 2.625H2.625V8.75H8.75V2.625Z"
              stroke="#B7B9C1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.375 2.625H12.25V8.75H18.375V2.625Z"
              stroke="#B7B9C1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.375 12.25H12.25V18.375H18.375V12.25Z"
              stroke="#B7B9C1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.75 12.25H2.625V18.375H8.75V12.25Z"
              stroke="#B7B9C1"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <button
            onClick={() => setSidebarOpen(false)}
            className="text-gray-600 lg:hidden focus:text-primary focus:outline-none">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M13.5 4.5L4.5 13.5"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.5 4.5L13.5 13.5"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        <hr className="my-1 border-gray-200" />

        <nav className="px-1  space-y-3">
          <NavLink
            to="/waiting-room"
            className={({ isActive }) =>
              `flex items-center justify-center py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }>
            {({ isActive }) => (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M2.25 4.5H12.75V2.25H2.25V4.5ZM9 12.75V6H2.25V12.75H9ZM10.5 12.75H12.75V6H10.5V12.75ZM1.5 0.75H13.5C13.6989 0.75 13.8897 0.829018 14.0303 0.96967C14.171 1.11032 14.25 1.30109 14.25 1.5V13.5C14.25 13.6989 14.171 13.8897 14.0303 14.0303C13.8897 14.171 13.6989 14.25 13.5 14.25H1.5C1.30109 14.25 1.11032 14.171 0.96967 14.0303C0.829018 13.8897 0.75 13.6989 0.75 13.5V1.5C0.75 1.30109 0.829018 1.11032 0.96967 0.96967C1.11032 0.829018 1.30109 0.75 1.5 0.75Z"
                  fill={isActive ? "#546CCC" : "#B7B9C1"}
                />
              </svg>
            )}
          </NavLink>

          <NavLink
            to="meeting-room"
            className={({ isActive }) =>
              `flex items-center justify-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }>
            {({ isActive }) => (
              <svg
                width="18"
                height="12"
                viewBox="0 0 18 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.032 6.00012L2 3.86012V8.14012L5.032 6.00012ZM0.788 11.4441C0.713106 11.4969 0.625151 11.5281 0.533741 11.5343C0.442331 11.5404 0.350979 11.5214 0.269661 11.4792C0.188342 11.437 0.120184 11.3732 0.072629 11.2949C0.0250738 11.2166 -5.03528e-05 11.1267 7.57649e-08 11.0351V0.965119C-5.03528e-05 0.8735 0.0250738 0.783628 0.072629 0.705317C0.120184 0.627007 0.188342 0.563267 0.269661 0.52106C0.350979 0.478853 0.442331 0.459801 0.533741 0.465984C0.625151 0.472166 0.713106 0.503347 0.788 0.556119L7.921 5.59212C7.98621 5.63832 8.0394 5.69947 8.07611 5.77046C8.11282 5.84145 8.13197 5.9202 8.13197 6.00012C8.13197 6.08004 8.11282 6.15879 8.07611 6.22978C8.0394 6.30077 7.98621 6.36192 7.921 6.40812L0.788 11.4441ZM11 8.14012L14.032 6.00012L11 3.86012V8.14012ZM9 0.965119C8.99995 0.8735 9.02507 0.783628 9.07263 0.705317C9.12018 0.627007 9.18834 0.563267 9.26966 0.52106C9.35098 0.478853 9.44233 0.459801 9.53374 0.465984C9.62515 0.472166 9.71311 0.503347 9.788 0.556119L16.921 5.59212C16.9862 5.63832 17.0394 5.69947 17.0761 5.77046C17.1128 5.84145 17.132 5.9202 17.132 6.00012C17.132 6.08004 17.1128 6.15879 17.0761 6.22978C17.0394 6.30077 16.9862 6.36192 16.921 6.40812L9.788 11.4441C9.71311 11.4969 9.62515 11.5281 9.53374 11.5343C9.44233 11.5404 9.35098 11.5214 9.26966 11.4792C9.18834 11.437 9.12018 11.3732 9.07263 11.2949C9.02507 11.2166 8.99995 11.1267 9 11.0351V0.965119Z"
                  fill={isActive ? "#546CCC" : "#B7B9C1"}
                />
              </svg>
            )}
          </NavLink>

          <NavLink
            to="settings"
            className={({ isActive }) =>
              `flex items-center justify-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }>
            {({ isActive }) => (
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9 11.25C10.2426 11.25 11.25 10.2426 11.25 9C11.25 7.75736 10.2426 6.75 9 6.75C7.75736 6.75 6.75 7.75736 6.75 9C6.75 10.2426 7.75736 11.25 9 11.25Z"
                  stroke={isActive ? "#546CCC" : "#B7B9C1"}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.55 11.25C14.4502 11.4762 14.4204 11.7271 14.4645 11.9704C14.5086 12.2137 14.6246 12.4382 14.7975 12.615L14.8425 12.66C14.982 12.7993 15.0926 12.9647 15.1681 13.1468C15.2436 13.3289 15.2824 13.5241 15.2824 13.7213C15.2824 13.9184 15.2436 14.1136 15.1681 14.2957C15.0926 14.4778 14.982 14.6432 14.8425 14.7825C14.7032 14.922 14.5378 15.0326 14.3557 15.1081C14.1736 15.1836 13.9784 15.2224 13.7812 15.2224C13.5841 15.2224 13.3889 15.1836 13.2068 15.1081C13.0247 15.0326 12.8593 14.922 12.72 14.7825L12.675 14.7375C12.4982 14.5646 12.2737 14.4486 12.0304 14.4045C11.7871 14.3604 11.5362 14.3902 11.31 14.49C11.0882 14.5851 10.899 14.7429 10.7657 14.9442C10.6325 15.1454 10.561 15.3812 10.56 15.6225V15.75C10.56 16.1478 10.402 16.5294 10.1207 16.8107C9.83936 17.092 9.45782 17.25 9.06 17.25C8.66218 17.25 8.28064 17.092 7.99934 16.8107C7.71804 16.5294 7.56 16.1478 7.56 15.75V15.6825C7.55419 15.4343 7.47384 15.1935 7.32938 14.9915C7.18493 14.7896 6.98305 14.6357 6.75 14.55C6.52379 14.4502 6.27286 14.4204 6.02956 14.4645C5.78626 14.5086 5.56176 14.6246 5.385 14.7975L5.34 14.8425C5.20069 14.982 5.03526 15.0926 4.85316 15.1681C4.67106 15.2436 4.47587 15.2824 4.27875 15.2824C4.08163 15.2824 3.88644 15.2436 3.70434 15.1681C3.52224 15.0926 3.35681 14.982 3.2175 14.8425C3.07804 14.7032 2.9674 14.5378 2.89191 14.3557C2.81642 14.1736 2.77757 13.9784 2.77757 13.7812C2.77757 13.5841 2.81642 13.3889 2.89191 13.2068C2.9674 13.0247 3.07804 12.8593 3.2175 12.72L3.2625 12.675C3.4354 12.4982 3.55139 12.2737 3.5955 12.0304C3.63962 11.7871 3.60984 11.5362 3.51 11.31C3.41493 11.0882 3.25707 10.899 3.05585 10.7657C2.85463 10.6325 2.61884 10.561 2.3775 10.56H2.25C1.85218 10.56 1.47064 10.402 1.18934 10.1207C0.908035 9.83936 0.75 9.45782 0.75 9.06C0.75 8.66218 0.908035 8.28064 1.18934 7.99934C1.47064 7.71804 1.85218 7.56 2.25 7.56H2.3175C2.56575 7.55419 2.8065 7.47384 3.00847 7.32938C3.21045 7.18493 3.36429 6.98305 3.45 6.75C3.54984 6.52379 3.57962 6.27286 3.5355 6.02956C3.49139 5.78626 3.3754 5.56176 3.2025 5.385L3.1575 5.34C3.01804 5.20069 2.9074 5.03526 2.83191 4.85316C2.75642 4.67106 2.71757 4.47587 2.71757 4.27875C2.71757 4.08163 2.75642 3.88644 2.83191 3.70434C2.9074 3.52224 3.01804 3.35681 3.1575 3.2175C3.29681 3.07804 3.46224 2.9674 3.64434 2.89191C3.82644 2.81642 4.02163 2.77757 4.21875 2.77757C4.41587 2.77757 4.61106 2.81642 4.79316 2.89191C4.97526 2.9674 5.14069 3.07804 5.28 3.2175L5.325 3.2625C5.50176 3.4354 5.72626 3.55139 5.96956 3.5955C6.21285 3.63962 6.46379 3.60984 6.69 3.51H6.75C6.97183 3.41493 7.16101 3.25707 7.29427 3.05585C7.42753 2.85463 7.49904 2.61884 7.5 2.3775V2.25C7.5 1.85218 7.65804 1.47064 7.93934 1.18934C8.22064 0.908035 8.60218 0.75 9 0.75C9.39782 0.75 9.77936 0.908035 10.0607 1.18934C10.342 1.47064 10.5 1.85218 10.5 2.25V2.3175C10.501 2.55884 10.5725 2.79463 10.7057 2.99585C10.839 3.19707 11.0282 3.35493 11.25 3.45C11.4762 3.54984 11.7271 3.57962 11.9704 3.5355C12.2137 3.49139 12.4382 3.3754 12.615 3.2025L12.66 3.1575C12.7993 3.01804 12.9647 2.9074 13.1468 2.83191C13.3289 2.75642 13.5241 2.71757 13.7213 2.71757C13.9184 2.71757 14.1136 2.75642 14.2957 2.83191C14.4778 2.9074 14.6432 3.01804 14.7825 3.1575C14.922 3.29681 15.0326 3.46224 15.1081 3.64434C15.1836 3.82644 15.2224 4.02163 15.2224 4.21875C15.2224 4.41587 15.1836 4.61106 15.1081 4.79316C15.0326 4.97526 14.922 5.14069 14.7825 5.28L14.7375 5.325C14.5646 5.50176 14.4486 5.72626 14.4045 5.96956C14.3604 6.21285 14.3902 6.46379 14.49 6.69V6.75C14.5851 6.97183 14.7429 7.16101 14.9442 7.29427C15.1454 7.42753 15.3812 7.49904 15.6225 7.5H15.75C16.1478 7.5 16.5294 7.65804 16.8107 7.93934C17.092 8.22064 17.25 8.60218 17.25 9C17.25 9.39782 17.092 9.77936 16.8107 10.0607C16.5294 10.342 16.1478 10.5 15.75 10.5H15.6825C15.4412 10.501 15.2054 10.5725 15.0042 10.7057C14.8029 10.839 14.6451 11.0282 14.55 11.25V11.25Z"
                  stroke={isActive ? "#546CCC" : "#B7B9C1"}
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </NavLink>

          <NavLink
            to="calendar"
            className={({ isActive }) =>
              `flex items-center justify-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }>
            {({ isActive }) => (
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.25 3H2.75C1.92157 3 1.25 3.67157 1.25 4.5V15C1.25 15.8284 1.92157 16.5 2.75 16.5H13.25C14.0784 16.5 14.75 15.8284 14.75 15V4.5C14.75 3.67157 14.0784 3 13.25 3Z"
                  stroke={isActive ? "#546CCC" : "#B7B9C1"}
                  strokeWidth="1.275"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M11 1.5V4.5"
                  stroke={isActive ? "#546CCC" : "#B7B9C1"}
                  strokeWidth="1.275"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 1.5V4.5"
                  stroke={isActive ? "#546CCC" : "#B7B9C1"}
                  strokeWidth="1.275"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.25 7.5H14.75"
                  stroke={isActive ? "#546CCC" : "#B7B9C1"}
                  strokeWidth="1.275"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </NavLink>

          <NavLink
            to="meeting-history"
            className={({ isActive }) =>
              `flex items-center justify-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }>
            {({ isActive }) => (
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 0.5C12.1423 0.5 15.5 3.85775 15.5 8C15.5 12.1423 12.1423 15.5 8 15.5C3.85775 15.5 0.5 12.1423 0.5 8H2C2 11.3135 4.6865 14 8 14C11.3135 14 14 11.3135 14 8C14 4.6865 11.3135 2 8 2C5.9375 2 4.118 3.04025 3.03875 4.625H5V6.125H0.5V1.625H2V3.5C3.368 1.6775 5.54675 0.5 8 0.5ZM8.75 4.25V7.68875L11.1823 10.121L10.121 11.1823L7.25 8.30975V4.25H8.75Z"
                  fill={isActive ? "#546CCC" : "#B7B9C1"}
                />
              </svg>
            )}
          </NavLink>

          <NavLink
            to="integration"
            className={({ isActive }) =>
              `flex items-center justify-center px-4 py-3 space-x-3  transition-colors duration-200 transform rounded-lg hover:text-gray-600  bg-opacity-40 ${
                isActive
                  ? "text-gray-600 bg-gray-200"
                  : "text-gray-500 hover:bg-gray-100"
              }`
            }>
            {({ isActive }) => (
              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.4977 0.000488281C11.6244 0.00131293 10.8149 0.457789 10.3622 1.20453C9.9096 1.95149 9.8795 2.88032 10.283 3.65494L4.65392 9.28403C3.94202 8.9127 3.09505 8.9059 2.37712 9.26568C1.65941 9.62566 1.1582 10.3085 1.03016 11.1012C0.901917 11.894 1.16232 12.6999 1.73014 13.2677C2.29795 13.8356 3.10386 14.0959 3.89663 13.9677C4.68939 13.8397 5.37222 13.3385 5.73197 12.6206C6.09195 11.9029 6.08515 11.0559 5.71362 10.344L11.3427 4.7149C12.0234 5.07118 12.8303 5.09468 13.5304 4.7784C14.2308 4.46213 14.7466 3.84133 14.9295 3.09496C15.1124 2.34879 14.9417 1.55977 14.4668 0.955689C13.992 0.351611 13.2659 -0.000543667 12.4975 0.000670296L12.4977 0.000488281ZM3.49914 12.4985C3.234 12.4985 2.97957 12.3933 2.79214 12.2057C2.60452 12.0183 2.49916 11.7639 2.49916 11.4987C2.49916 11.2336 2.60452 10.9792 2.79214 10.7917C2.97955 10.6041 3.23397 10.499 3.49914 10.499C3.76427 10.499 4.01849 10.6041 4.20613 10.7917C4.39355 10.9791 4.4989 11.2336 4.4989 11.4987C4.4989 11.7639 4.39355 12.0183 4.20613 12.2057C4.01851 12.3933 3.7643 12.4985 3.49914 12.4985ZM12.4977 3.49987C12.2326 3.49987 11.9782 3.39451 11.7907 3.2071C11.6031 3.01948 11.4979 2.76526 11.4979 2.50009C11.4979 2.23495 11.6031 1.98053 11.7907 1.79309C11.9781 1.60547 12.2326 1.50012 12.4977 1.50012C12.7629 1.50012 13.0173 1.60547 13.2047 1.79309C13.3923 1.98051 13.4975 2.23493 13.4975 2.50009C13.4975 2.76523 13.3923 3.01945 13.2047 3.2071C13.0173 3.39451 12.7629 3.49987 12.4977 3.49987Z"
                  fill={isActive ? "#546CCC" : "#B7B9C1"}
                />
                <path
                  d="M12.7471 10.4985C12.7471 10.8299 12.6156 11.1478 12.3811 11.3822C12.1467 11.6166 11.8288 11.7482 11.4975 11.7482H7.74805V13.2479L11.4975 13.2481C12.2265 13.2481 12.926 12.9582 13.4417 12.4427C13.9571 11.9271 14.247 11.2276 14.247 10.4985V6.74902H12.7471L12.7471 10.4985Z"
                  fill={isActive ? "#546CCC" : "#B7B9C1"}
                />
                <path
                  d="M3.24975 3.50002C3.24975 3.1687 3.3815 2.85076 3.61592 2.61637C3.85035 2.38195 4.16828 2.2502 4.49959 2.2502H8.24912V0.750488H4.49959C3.77036 0.750488 3.07101 1.04016 2.55534 1.55582C2.03966 2.07147 1.75 2.77083 1.75 3.50005V7.24953H3.24973L3.24975 3.50002Z"
                  fill={isActive ? "#546CCC" : "#B7B9C1"}
                />
              </svg>
            )}
          </NavLink>
        </nav>

        <hr className="my-6 border-gray-200" />

        <div className="px-1 pt-4 pb-10 flex flex-col items-center justify-center">
          <NavLink
            to="/profile"
            className="flex items-center justify-center mt-4 space-x-3 text-lg font-bold text-gray-800 hover:text-gray-700 hover:underline">
            <img src={useImg} alt="" />
          </NavLink>

          <Link
            to="/logout"
            className="flex items-center mt-8 space-x-3 font-bold text-gray-400 hover:text-gray-500 hover:underline">
            <svg
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.5">
                <path
                  d="M5.25 12.9648H2.91667C2.60725 12.9648 2.3105 12.8419 2.09171 12.6231C1.87292 12.4043 1.75 12.1076 1.75 11.7982V3.63151C1.75 3.32209 1.87292 3.02534 2.09171 2.80655C2.3105 2.58776 2.60725 2.46484 2.91667 2.46484H5.25"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.33398 10.6315L12.2507 7.71482L9.33398 4.79816"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.25 7.71484H5.25"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
            </svg>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
